import React from "react";
import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    LabelList,
    ResponsiveContainer,
    XAxis,
    YAxis
} from "recharts";
import { useTheme } from "styled-components";
import { useReport } from "../../../contexts/ReportContext";

const data = [
  { name: "Page A", value: 400 },
  { name: "Page B", value: 300 },
  { name: "Page C", value: 300 },
  { name: "Page D", value: 200 },
  { name: "Page F", value: 189 },
];

const renderCustomizedLabel = (props: any) => {
  const { x, y, width, height, value } = props;
  const radius = 10;

  return (
    <g>
      <text
        x={x + width / 2}
        y={y - radius - 35}
        fill="#000"
        textAnchor="middle"
        fontWeight={"bold"}
        dominantBaseline="middle"
      >
        {value}
      </text>
      <text
        x={x + width / 2}
        y={y - radius - 10}
        fill="#c3c3c3"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        Oocyte
      </text>
    </g>
  );
};

const BarChartWithLabelLines: React.FC = () => {
  const { colorStyle } = useReport();
  const theme = useTheme();

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          strokeWidth={0}
          dataKey="name"
          tick={{ fontWeight: "bold" }}
          dy={20}
        />
        <YAxis strokeWidth={0} tick={{ fontWeight: "bold" }} dx={-10} />
        <Bar
          dataKey="value"
          fill="#00a0fc"
          strokeWidth={1}
          radius={[15, 15, 15, 15]}
        >
          <LabelList
            dataKey="value"
            position={"top"}
            content={renderCustomizedLabel}
          />
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={theme.palette.reportColorStyles[colorStyle].main}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartWithLabelLines;
